export enum TableFilter {
  Primary = "primary",
  Secondary = "secondary",
}
